import { Stack } from '@fluentui/react'
import { DashboardData } from '../../state/AppProvider'
import StatCard from '../common/StatCard'

type SummaryCardsProps = {
  data: DashboardData
}

const SummaryCards = ({ data }: SummaryCardsProps) => {
  const totalQuestions = data.activeUsers
    ? data.activeUsers.users.reduce((sum, u) => sum + u.questions_asked, 0)
    : 0

  const uniqueUsers = data.activeUsers?.total_active_users ?? 0
  const conversations = data.conversationCount?.total ?? 0
  const positive = data.feedbackSummary?.positive ?? 0
  const negative = data.feedbackSummary?.negative ?? 0

  return (
    <Stack horizontal tokens={{ childrenGap: 16 }} styles={{ root: { flexWrap: 'wrap' } }}>
      <StatCard title="Total Questions" value={totalQuestions.toLocaleString()} color="#2B3A67" />
      <StatCard title="Conversations" value={conversations.toLocaleString()} color="#496A99" />
      <StatCard title="Unique Users" value={uniqueUsers.toLocaleString()} color="#8BACC4" />
      <StatCard title="Positive Feedback" value={positive.toLocaleString()} color="#5B8A72" />
      <StatCard title="Negative Feedback" value={negative.toLocaleString()} color="#D4775B" />
    </Stack>
  )
}

export default SummaryCards
